import axios from 'axios'

const instance = axios.create({
    // baseURL: 'http://2b637426.ngrok.io/'
    // baseURL: 'https://liveapi.neotebet.de/'
    baseURL: 'https://livev2apidev.dyned.com.cn/'
    // baseURL: 'https://www.googleapis.com/identitytoolkit/v3/relyingparty/'
})

export default instance;



// WEBPACK FOOTER //
// ./src/store/axios-auth.js